import { render, staticRenderFns } from "./RejectSign.vue?vue&type=template&id=bdc391d8"
import script from "./RejectSign.vue?vue&type=script&lang=js"
export * from "./RejectSign.vue?vue&type=script&lang=js"
import style0 from "./RejectSign.vue?vue&type=style&index=0&id=bdc391d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports